module.exports = __webpack_public_path__ + "img/a2.dd0e0ae5.png";